// import { REHYDRATE } from 'redux-persist/constants';
// import { GET_FAQ_FAILURE, GET_FAQ_REQUEST, GET_FAQ_SUCCESS } from '../actions';
import React from 'react';

const initialState = {
	data: [
		{
			id: 7,
			title: 'BeeWhisper.com',
			image: './images/projects/beewhisper.jpg',
			shortDesc: `A one-page app that features a bee venom collector.`,
			url: `https://www.beewhisper.com`,
			urlTitle: 'beewhisper',
			difficulty: '6',
			tags: ['Headless CMS', 'Authentication', 'PHP API', 'ReactJS', 'Redux', 'API-Middleware', 'Persister'],
			year: '2018-2019',
			problemContent: (
				<div>
					<p>
						This was a side project, it involved re-designing an existing site. Only one product is featured on it, but
						it does have a cart, an easy to use purchase system, review management system, headless CMS support and
						protected routes. More about its features in the next section.
					</p>
				</div>
			),
			solutionContent: (
				<div>
					<h4>Components</h4>
					<p>
						I really liked the approach we took with the HSA management platform, so I was looking for a component
						library. Picked MaterialUI and made wrappers for each of its most common components. The wrappers had a
						color theme I could pass, in case going with specific colors didn't turn up to be a good idea.
					</p>
					<h4>Forms</h4>
					<p>
						For forms I already had a repo with wrapped redux-form components that I was using to bootstrap new apps,
						had zero issues handling validation and events.
					</p>
					<h4>Authentication</h4>
					<p>
						The project required a set of pages to be protected and be used for administration. Authentication was
						handled by a MySQL database and credentials were passed via URL query params. The purpose was to make
						administration as easy as following a link and getting things done fast.
					</p>
					<h4>API</h4>
					<p>
						I had to build an API for this project and it was using shared hosting, so certain features like AWS Lambda
						weren't available to make it serverless, and deploying a Java or NodeJS API wasn't an option either.
					</p>
					<p>
						So the solution was to use PHP. I wrote an API that supports CRUD operations, query filters, custom response
						shaping, couple other features.
					</p>
					<h4>Headless CMS</h4>
					<p>To customize content I used a headless CMS, data was stored in MySQL.</p>
					<h4>Third Party Services</h4>
					<p>The app's using an API that matches user's API to a country - geolocation API.</p>
					<p>It also uses an API to track currency conversion rates.</p>
					<h4>Reviews System</h4>
					<p>
						There's a custom reviews system built in the app, has 2 sides: one allows for reviews to be approved and for
						review codes to be generated; the other allows for customers to use a generated link with their credentials
						and visit a route in the app where they could drop a review. As a customer it's really easy to drop a review
						and it being a one-page app makes the process extremely smooth.
					</p>
				</div>
			),
		},
		// End of BeeWhisper
		{
			id: 6,
			title: 'HSA management platform',
			image: './images/projects/hsa.jpg',
			shortDesc: `A project for a Fortune 500 company, replacing their existing system. Solution is currently used in a few thousand stores.`,
			url: false,
			urlTitle: 'hsa-management-platform',
			difficulty: '9',
			tags: ['HSA', 'ReactJS', 'Redux', 'API-Middleware', 'Persister'],
			year: '2017-2018',
			problemContent: (
				<div>
					<p>
						The client was looking to replace their old front-end solution. It was slow with poor error handling,
						minimal validation that resulted in generic error messages, UI looked dated.
					</p>
					<p>
						The platform was quite big and consisted of 4 different portals:
						<ul>
							<li>Participants</li>
							<li>Sponsors/Advisors</li>
							<li>Administrators</li>
							<li>Separate section for CMS</li>
						</ul>
					</p>
					<p>
						You have to register and enroll in an HSA plan and those flows diverged for the different user types. User
						types included:
						<ul>
							<li>A normal free-agent</li>
							<li>An employee that was uploaded via csv file</li>
							<li>An employee that chose to self-enroll</li>
							<li>Some other types that were combinations of the previous 3</li>
						</ul>
					</p>
				</div>
			),
			solutionContent: (
				<div>
					<h4>The setup</h4>
					<p>
						This project we started a little bit different. We knew it'll be quite large and keeping projects like that
						consistent (both code and feel) isn't simple. Component libraries have been around for years -- MaterialUI,
						some Bootstrap-based ones, etc. But we didn't use those, we started our own. And it was hard.
					</p>
					<p>
						The project started developing while the component library was still under development. It took a bit of
						back and forth, but at some point the constant changes stopped, things settled down and the rest was easy.
					</p>
					<h4>Forms</h4>
					<p>
						For forms we used redux-form, which is a form state management library, state is stored in a redux reducer.
						I wrapped every field type in its own component so we have more control of them, but the end component was
						still the above component library that we built. It took some doing until it was working predictably, but
						after a while even complex form validation (async, sync, field-level, array-level) wasn't taking much time
						to set up, and time's money.
					</p>
					<h4>Portal split</h4>
					<p>
						So we had to split the application into 4 different portals, initially we assumed it'd be 4 applications but
						it wasn't. The split required redux store to be split into 5 - one for each portal, one shared.
					</p>
					<p>
						Obviously we used the same components, but there was code-splitting involved too -- including the action
						creators.
					</p>
					<h4>Fallbacks</h4>
					<p>
						The app handles money, so fallbacks were important. I did most of those, but was also keeping track of the
						overall code so we don't miss any. The app went into production with very very minimal crashes, I think the
						first day we actually had none and it took very edge cases to crash it.
					</p>
					<h4>CMS-driven</h4>
					<p>
						The application was CMS driven, we were responsible for a UAT database with content along with the client,
						and our INT and QA environments were managed by one of the client's vendors. I didn't have much contribution
						here.
					</p>
					<h4>Accessibility</h4>
					<p>
						I think this was the first project with so many accessibility features. I didn't take place in this part
						either, but lucky for us one of RTS' new hires knew how to do it well.
					</p>
					<h4>Result</h4>
					<p>
						Right now the app's used in production and is handling the user flow pretty well. We're working on next
						phases and are pretty happy with the initial version of this product. Or I feel good about it.
					</p>
				</div>
			),
		},
		// End of HSA Platform
		{
			id: 5,
			title: 'Healthcare management app',
			image: './images/projects/healthcare.jpg',
			shortDesc: `So this was a mobile app that helped you manage dependents, your healthcare providers, your info and also related documents.`,
			url: false,
			urlTitle: 'healthcare-management-app',
			difficulty: '5',
			tags: ['Healthcare', 'Mobile', 'Redux-saga', 'Cognito', 'ReactJS', 'Redux', 'API-Middleware', 'Persister'],
			year: '2018',
			problemContent: (
				<div>
					<p>
						As a user, you could register. After registration you had to activate account, which included a couple steps
						and some of them could be finished later after login.
					</p>
					<p>
						After completing activation you were guided to a "Health Hub", which allowed you to manage your healthcare
						providers, choose from different practices in an area, check your Care Plans, manage your dependents.
					</p>
				</div>
			),
			solutionContent: (
				<div>
					<p>
						Won't go too much into detail, I was just supporting this project so don't want to steal other people's
						glory. It was the first professional project that I have worked on that supported redux-saga, instead of
						thunk.
					</p>
				</div>
			),
		},
		// End of Healthcare management app
		{
			id: 4,
			title: 'Auto Parts Delivery Tracking',
			image: './images/projects/autoparts.jpg',
			shortDesc: `A project for a Fortune 500 company, replacing their existing system. Solution is currently used in a few thousand stores.`,
			url: false,
			urlTitle: 'auto-parts-delivery-tracking',
			difficulty: '8',
			tags: ['ReactJS', 'Redux', 'API-Middleware', 'Persister'],
			year: '2017',
			problemContent: (
				<div>
					<p>
						Their existing system was old, was slowing drivers down and didn't have the convenience of a modern app. Its
						purpose was to keep track of deliveries, keep track of drivers and all of their driving patterns via GPS
						device, streamline the process from getting an order to delivering it.
					</p>
					<p>
						The front-end goals:
						<ul>
							<li>Make it fast and responsive</li>
							<li>Tablet devices to be fully supported</li>
							<li>Handle real-time data</li>
							<li>Integrate maps and geolocation</li>
						</ul>
					</p>
				</div>
			),
			solutionContent: (
				<div>
					<h4>The start</h4>
					<p>
						It started with mocks and wireframes, they were designed by someone that is no longer with RTS Labs. Design
						was clean and uncluttered, we introduced a color theme that matched the client's.
					</p>
					<p>
						Next step was to build up boilerplate components which we then styled. And slowly we started integrating
						them into the app.
					</p>
					<h4>The middle</h4>
					<p>
						As the project started shaping up and back-end microservices were more complete, we started organizing trips
						to local shops to meet their crew. I think in total we went to 4 local shops, met drivers and store
						managers, talked over what more to include to make it easier for them to operate. Got quite a lot of ideas
						which we later implemented.
					</p>
					<h4>The rewards</h4>
					<p>
						The project was risky and chances of it being adopted by a company of that size weren't quite that high. So
						it was amazing to hear good feedback at the end of Phase I, the app was introduced to 10 stores. The old app
						was not completely obsolete yet and both were used interchangeably. After the 10 stores it was introduced to
						50, then to 100 and plans were announced to slowly integrate it in all stores, completely replacing the old
						platform.
					</p>
				</div>
			),
		},
		// End of Auto Parts delivery tracking
		{
			id: 3,
			title: 'Church Management Service',
			image: './images/projects/church-management.png',
			shortDesc: `Data visualization with Yellowfin BI integration, complex user access roles and permissions to 
				match the real world church organization and UI for normal church-goers.`,
			url: false,
			urlTitle: 'church-management-service',
			difficulty: '7',
			tags: ['ReactJS', 'Redux', 'API-Middleware', 'Persister', 'Roles', 'Permissions', 'Yellowfin'],
			year: '2016-2017',
			problemContent: (
				<div>
					<p>
						We had to build an app that was broken down in several different levels of user roles:
						<ul>
							<li>Pastors</li>
							<li>Church Administrators</li>
							<li>Administrators on the Client's Side</li>
							<li>Registered Church Users</li>
							<li>Registered Guest Users</li>
						</ul>
					</p>
					<p>
						Data visualization with Yellowfin was to be done in 2 parts:
						<ul>
							<li>Back-end generated reports</li>
							<li>Front-end integration with those reports</li>
						</ul>
					</p>
					<p>
						The app was the wasme for all users, but meant to be used in completely different ways. For example, Church
						Administrators were mostly handling their own church information and events. Registered Church Users had
						access to special worship services that guests didn't and Pastors were managing multiple churches on a
						higher level.
					</p>
				</div>
			),
			solutionContent: (
				<div>
					<h4>Bringing ReactJS and Bootstrap theme together</h4>
					<p>
						So front-end started with bringing a bootstrap theme and a normal ReactJS app together. Most bootstrap
						themes rely on jQuery for animations, but React doesn't play well with it -- I had to make a list of all
						jQuery script and then converted them to React compatible functions.
					</p>
					<h4>Roles and Permissions</h4>
					<p>
						After the initial phase was completed, I built wrappers to handled Roles and Permissions. Each Role had a
						set of permissions, but Permissions could also vary per Role. For testing we had a large excel spreadsheet
						that outline what each Role should see with a basic list of permissions, and then we had test cases for the
						outliers.
					</p>
					<h4>Yellowfin integration</h4>
					<p>
						I think integration was almost intuitive, but then Yellowfin wasn't made to work well with single-page apps
						at the time. To make it more predictable, I built wrappers for reports and dashboards. Responsiveness was
						still an issue however, since reports were rendered in a frame we couldn't control much. Even then, adding
						style wrappers and some auxiliary css made it look respectable on mobile devices.
					</p>
				</div>
			),
		},
		// End of Church Management
		{
			id: 2,
			title: 'Auto Insurance Quoting Service',
			image: './images/projects/auto-insurance.jpg',
			shortDesc: `A challenge to make the process faster and as reliable as similar services`,
			url: false,
			urlTitle: 'auto-insurance-quoting-service',
			difficulty: '4',
			tags: ['ReactJS', 'Redux', 'Persister', 'Bootstrap', 'JavaScript'],
			year: 2016,
			problemContent: (
				<div>
					<p>
						The concept behind the project was to recreate the process of getting your auto insurance quote, but making
						it faster than similar apps.
					</p>
				</div>
			),
			solutionContent: (
				<div>
					<p>
						There are a ton of insurance quoting apps, we were competing against insurance giants like Geico. When I
						joined the project, it was a proof of concept, done in Bootstrap, jQuery and JavaScript. It was fast, but it
						wasn't a one-page app and had its flaws.
					</p>
					<p>
						As the project kept growing from a PoC to an actual application, I had issues with persisting data properly
						and performance overall wasn't that amazing. After talking to PMs, I took it up on myself to convert the
						existing project to a React app. It took a lot of overtime work that wasn't even billable, but the project
						was successfully converted with about 95% of the functionality intact.
					</p>
					<p>
						The project wasn't bootstrapped with something like create-react-app, it was built from the ground up. In
						the process, I learned how all the little things interact with each other, from an ES linter to tests.
						Nevertheless, it was valuable to learn the foundations before moving on.
					</p>
					<h6>Notable Features:</h6>
					<ol>
						<li>Very very mobile-friendly</li>
						<li>Whitelabel branding</li>
						<li>Complex front-end data storage and persisting</li>
						<li>Fast and snappy</li>
						<li>Fast loading</li>
						<li>Error handling</li>
					</ol>
					<p>
						It took about 6 or 8 months for the whole project to be completed and production-ready. The client asked us
						to support mobile devices and with the help of a designer we made it rock-solid -- older devices, odd
						browser versions, different OSs, portrait and landscape modes.
					</p>
				</div>
			),
		},
		// End of Auto Quoting
		{
			id: 1,
			title: 'Financial auditing tool',
			image: './images/projects/financial-auditing.jpg',
			shortDesc: `A privately used tool for financial auditing and various financial calculators.`,
			url: false,
			urlTitle: 'financial-calculator-auditing-tool',
			difficulty: '3',
			tags: ['Bootstrap', 'JavaScript', 'CoffeeScript', 'Ruby', 'Rails'],
			year: 2016,
			problemContent: (
				<div>
					<p>
						The company needed a solution for a problem that had 2 parts:
						<br />
						<br />
					</p>
					<ol>
						<li>
							A front-end portion which employees would use as a tool to do various financial calculators when
							communicating with clients;
						</li>
						<li>
							A (mostly) back-end portion, which handled financial transactions and help with discovering discrepancies.
						</li>
					</ol>
				</div>
			),
			solutionContent: (
				<div>
					<p>
						I built the front-end portion as a pretty traditional (at the time) Bootstrap theme page. Math was handled
						by Javascript and we had a little bit of jQuery in the mix to help with modest animations. The application
						wasn't meant to be used by the company's clients, so the priority was to make it fast and responsive, rather
						than flashy. The complexity on the FE came from building the JS logic to be reliable and the finance sector
						requires extra attention to details to make numbers very very precise.
					</p>
					<p>
						The back-end portion was built in Ruby on Rails by someone else. It was integrated with the front-end and we
						used CoffeeScript, some front-end portions were styled but purely back-end generated.
					</p>
				</div>
			),
		},
	],
	isLoading: false,
};

const projects = (state = initialState, action) => {
	switch (action.type) {
		default:
			return state;
	}
};

export default projects;



// WEBPACK FOOTER //
// ./src/reducers/projects.js